import React from 'react'
import { Button } from '../Shared'


const Modal = props => {

	const {
		children,
		className,
		closeModal,
		direction,
		isOpen
	} = props

	let isOpenClass = isOpen ? '_open' : ''

	return (
		<>
			<Button
				className={`modalOverlay ${isOpenClass}`}
				onClick={closeModal}
			></Button>
			<div className={`modal ${isOpenClass} ${className}`}>
				<div className={`_content ${direction}`}>
					{children}
				</div>
			</div>
		</>
	)

}


export default Modal
